

































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import {
  addEviSubject,
  updateEviSubject,
  deleteEviSubject,
  getEviSubjectPageList,
  defaultEviSubjectData,
  getSubjectDigest
} from "@/api/evisubject";
import { subjectTypeDic } from "@/enum/index";
import { IEviSubject } from "@/model/evisubject";
import {
  getSubjectbehaviorFromDict,
  saveAsync,
  deleteByDictId
} from "@/api/evisubjectbehavior";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: "eviSubject",
  components: {
    Pagination
  },
  filters: {
    subjectTypeDicFilter: (key: number) => {
      return subjectTypeDic.find((o: any) => o.key === key)?.value;
    }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private tableKeyDict = 1;
  private eviSubjectData = defaultEviSubjectData;
  private list: IEviSubject[] = [];
  private CurrectDictList: any[] = [];
  private dictTemplateIds = [];
  private total = 0;
  private listLoading = false;
  private subjectTypeDic = subjectTypeDic;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: "",
    subjectType: -1
  };

  private subjectDigest = ""; // 主体消息摘要

  private dialogCreateVisible = false;
  private dialogDictVisible = false;
  private dialogSubjectDigestVisible = false;

  private createRules = {
    subjectType: [
      {
        type: "number",
        min: 0,
        required: true,
        message: "主体类别必填",
        trigger: "change"
      }
    ],

    subjectName: [{ required: true, message: "主体名称必填", trigger: "blur" }]
  };

  private openCreateDialog() {
    this.initData();
    this.dialogCreateVisible = true;
  }

  private closeCreateDialog() {
    (this.$refs.createForm as Form).resetFields();
    this.dialogCreateVisible = false;
  }

  private handleFilter() {
    this.listQuery.pageIndex = 1;
    this.getList();
  }

  created() {
    this.getList();
  }

  private handleUpdate(data: IEviSubject) {
    // this.eviAppData = data;
    this.setData(data);
    this.dialogCreateVisible = true;
  }

  private handleDictTemplate(data: IEviSubject) {
    this.setData(data);
    this.getCurrectDictList(data.id).then(() => {
      if (this.CurrectDictList.length === 0) {
        this.$message({
          message: "请先配置主体模板数据字典!"
        });
      } else {
        this.dialogDictVisible = true;
      }
    });
  }

  private async confirmEdit(data: any) {
    data.edit = false;
    data.originalValue = data.value;
    await saveAsync(data).then(() => {
      this.$message({
        type: "success",
        message: "保存成功!"
      });
    });
  }

  private async deleteByDictId(data: any) {
    this.$confirm("此操作将永久删除, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteByDictId(data.dictId).then(() => {
          data.value = "";
          data.originalValue = "";
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async getCurrectDictList(pid: string) {
    const { data } = await getSubjectbehaviorFromDict(pid);

    if (data === null) {
      this.CurrectDictList = [];
      return;
    }

    this.CurrectDictList = data.map((v: any) => {
      this.$set(v, "edit", false); // https://vuejs.org/v2/guide/reactivity.html
      v.originalValue = v.value; // will be used when user click the cancel botton
      return v;
    });
  }

  private cancelEdit(row: any) {
    row.value = row.originalValue;
    row.edit = false;
    this.$message({
      message: "取消编辑操作",
      type: "warning"
    });
  }

  private initData() {
    this.eviSubjectData.id = "";
    this.eviSubjectData.subjectType = -1;
    this.eviSubjectData.subjectName = "";
    this.eviSubjectData.memberId = "";
    this.eviSubjectData.creatorId = "";
    this.eviSubjectData.createTime = null;
    this.eviSubjectData.updateTime = null;
    this.eviSubjectData.updateId = "";
    this.eviSubjectData.isActive = false;
  }

  private setData(data: IEviSubject) {
    this.eviSubjectData.id = data.id;
    this.eviSubjectData.subjectType = data.subjectType;
    this.eviSubjectData.subjectName = data.subjectName;
    this.eviSubjectData.memberId = data.memberId;
    this.eviSubjectData.creatorId = data.creatorId;
    this.eviSubjectData.createTime = data.createTime;
    this.eviSubjectData.updateTime = data.updateTime;
    this.eviSubjectData.updateId = data.updateId;
    this.eviSubjectData.isActive = data.isActive;
  }

  private async getSubjectDigest(id: string) {
    await getSubjectDigest(id).then(res => {
      this.subjectDigest = res.data;
      this.dialogSubjectDigestVisible = true;
    });
  }

  private deleteEviSubject(id: string) {
    this.$confirm("此操作将永久删除, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteEviSubject(id).then(() => {
          this.getList();

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async update() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await updateEviSubject(this.eviSubjectData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogCreateVisible = false;
        this.getList();
      }
    });
  }

  private async create() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await addEviSubject(this.eviSubjectData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogCreateVisible = false;
          this.getList();
        });
      }
    });
  }

  // 获取列表数据
  private async getList() {
    this.listLoading = true;
    const { data } = await getEviSubjectPageList(this.listQuery);
    this.list = data.list;
    this.total = data.total;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }
}
